import { useMemo } from "react";
import type { Email, TranscriptRecord } from "../types";
import { css } from "../../../../styled-system/css";

const EmailBox = ({ transcriptData }: { transcriptData: TranscriptRecord[] }) => {
  const email: Email | undefined = useMemo(() => {
    const emailItems = transcriptData.filter((item) => item.type === "email");

    if (emailItems.length === 0) {
      return undefined;
    }
    try {
      if (emailItems[0]?.content) {
        return JSON.parse(emailItems[0].content) as Email;
      }
      return undefined;
    } catch {
      return undefined;
    }
  }, [transcriptData]);

  if (!email) {
    return <div>No email found.</div>;
  }

  return (
    <div className={css({ fontSize: "medium" })}>
      <div className={css({ display: "flex" })}>
        <div>
          <div className={css({ marginBottom: "3", paddingBottom: "1", fontSize: "3xl", fontWeight: "bold" })}>
            Subject: {email.subject}
          </div>

          <div>
            <div className={css({ marginBottom: "2" })}>{email.greeting}</div>
            <div className={css({ marginBottom: "4" })}>{email.intro}</div>

            <div className={css({ marginTop: "3", fontWeight: "bold" })}>Summary</div>
            <ul className={css({ marginBottom: "3" })}>
              {email.summary_bullets.map((bullet, index) => (
                <li key={index}>{bullet}</li>
              ))}
            </ul>

            <div className={css({ marginTop: "3", fontWeight: "bold" })}>{email.next_steps_heading}</div>
            <ul className={css({ marginBottom: "4" })}>
              {email.next_steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>

            <div className={css({ marginBottom: "1" })}>{email.closing}</div>
            <div className={css({ marginTop: "4", marginBottom: "0" })}>{email.sign_off},</div>
            <div className={css({ marginTop: "2", marginBottom: "0", fontWeight: "semibold" })}>{email.sender}</div>
            <div className={css({ color: "#888" })}>{email.team}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailBox;
